/** @typedef {string} CustomerGroupStatus */
export const CUSTOMER_GROUP_STATUS_ACTIVE = 'ACTIVE';
export const CUSTOMER_GROUP_STATUS_DEACTIVATED = 'DEACTIVATED';
export const CUSTOMER_GROUP_STATUS_EXPIRED = 'EXPIRED';
/** @enum {CustomerGroupStatus} */
export const CUSTOMER_GROUP_STATUS = {
	ACTIVE: CUSTOMER_GROUP_STATUS_ACTIVE,
	DEACTIVATED: CUSTOMER_GROUP_STATUS_DEACTIVATED,
	EXPIRED: CUSTOMER_GROUP_STATUS_EXPIRED,
};
/** @type {CustomerGroupStatus[]} */
export const CUSTOMER_GROUP_STATUSES = [
	CUSTOMER_GROUP_STATUS.ACTIVE,
	CUSTOMER_GROUP_STATUS.DEACTIVATED,
	// @note EXPIRED is not used at the moment. It will be used in the future when API supports it.
	// CUSTOMER_GROUP_STATUS.EXPIRED,
];

export const CUSTOMER_GROUP_STATUS_COLOR_CLASS = {
	[CUSTOMER_GROUP_STATUS.ACTIVE]: 'success-color',
	[CUSTOMER_GROUP_STATUS.DEACTIVATED]: 'faded-color',
	[CUSTOMER_GROUP_STATUS.EXPIRED]: 'error-color',
};
export const CUSTOMER_GROUP_STATUS_BKG_COLOR_CLASS = {
	[CUSTOMER_GROUP_STATUS.ACTIVE]: 'success',
	[CUSTOMER_GROUP_STATUS.DEACTIVATED]: 'faded',
	[CUSTOMER_GROUP_STATUS.EXPIRED]: 'error',
};